<template>
  <div class="tabs">
    <div
      class="tab"
      v-for="(question, index) in questions"
      :class="[
        selected_question && selected_question.id === question.id ? 'selected' : null,
        question.is_correct_answer ? 'correct' : 'incorrect'
      ]"
      @click="$emit('select', question)">
      <span class="number">{{ index + 1 }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bcg-response-tab-test-question-tabs',
    props: {
      questions: {
        type: Array,
        required: true,
      },
      selected_question: {
        type: Object,
        default: null,
      },
    }
  }
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.tabs {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .tab {
    box-sizing: border-box;
    width: 10%;
    height: 40px;
    border: 1px solid #e5e5e5;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;

    &.correct {
      color: $green;
    }

    &.incorrect {
      color: $red-color;
    }

    &.selected {
      background-color: #f2f2f2;
      font-weight: 500;
    }
  }
}
</style>
